import { elementFactory } from "./factory.js";
import { network } from "../network.js";
export class navigationMenu {

    constructor(containerEl, gameState, uiManager) {
        this.gameState = gameState;

        this.container = containerEl;

        this.uiManager = uiManager;

        //  <div id="nav-debug-controls">
        //         <div class="nav-control-group">
        //             <button class="nav-action-btn" id="zoom-out-btn">-</button>
        //             <button class="nav-action-btn" id="zoom-in-btn">+</button>
        //             <button class="nav-action-btn" id="map-reset-btn">RESET</button>
        //         </div>
        //         <button class="nav-toggle-btn">
        //             <div id="nav-toggle-square"></div>
        //         </button>
        //         <div class="nav-teleport-group">
        //             <input type="text" class="nav-coord-input" id="teleport-x" placeholder="X" autocomplete="off" />
        //             <input type="text" class="nav-coord-input" id="teleport-y" placeholder="Y" autocomplete="off" />
        //             <button class="nav-action-btn" id="teleport-submit-btn">TP</button>
        //         </div>
        //     </div>

        this.ui = {
            navControls: this.container.querySelector("#nav-debug-controls"),
            zoomOutBtn: this.container.querySelector("#zoom-out-btn"),
            zoomInBtn: this.container.querySelector("#zoom-in-btn"),
            resetZoomBtn: this.container.querySelector("#map-reset-btn"),
            gridContainer: this.container.querySelector("#grid-exploration"),
            navToggleBtn: this.container.querySelector(".nav-toggle-btn"),
            inputX: this.container.querySelector("#teleport-x"),
            inputY: this.container.querySelector("#teleport-y"),
            teleportBtn: this.container.querySelector("#teleport-submit-btn")
        }


        this.mpText = this.container.querySelector("#top-bar-mp-text")
        this.lastMPValue = new Decimal(-1);

        this.minMapSize = 3;
        this.maxMapSize = 15;
        this.baseMapSize = 5;

        this.currentMapSize = this.baseMapSize;
    }




    init() {
        this.setupZoomButtons();
        this.setupGridInteractions();

        network.onWorldUpdate = () => {
            this.drawGrid();
        };

        this.drawGrid();
    }

    setupZoomButtons() {
        this.container.addEventListener('wheel', (e) => {
            e.preventDefault();
            if (e.deltaY < 0) {
                this.updateMapSize(-2); // Zoom in
                this.drawGrid();
            } else {
                this.updateMapSize(2);  // Zoom out
                this.drawGrid();
            }
        }, { passive: false });

        this.ui.zoomOutBtn.addEventListener('click', () => {
            this.updateMapSize(2)
            this.drawGrid();
        })

        this.ui.zoomInBtn.addEventListener('click', () => {
            this.updateMapSize(-2)
            this.drawGrid();
        })

        this.ui.resetZoomBtn.addEventListener('click', () => {
            this.currentMapSize = this.baseMapSize;
            this.drawGrid();
        })

        this.ui.navToggleBtn.addEventListener('click', () => {
            this.ui.navControls.classList.toggle('collapsed');
        });

        this.ui.teleportBtn.addEventListener('click', () => {
            this.doTeleport();
        })
    }

    updateMapSize(amount) {
        let newMapSize = this.currentMapSize + amount;
        if (newMapSize <= this.maxMapSize && newMapSize >= this.minMapSize) {
            this.currentMapSize = newMapSize;
        }

        //console.log(this.currentMapSize);
    }

    updateNavPlaceholders(xPos, yPos) {
        this.ui.inputX.placeholder = `X: ${xPos}`
        this.ui.inputY.placeholder = `Y: ${yPos}`
    }

    doTeleport() {
        const coords = this.getCoordinates();
        if (!coords) {
            return;
        }

        const tile = this.gameState.worldHandler.getActiveWorld()?.getTile(coords.x, coords.y);

        if (tile === "empty") {
            return;
        }

        this.gameState.moveCenter(coords.x, coords.y);

        this.drawGrid();
    }

    resetTeleportInputs() {
        this.ui.inputX.value = null;
        this.ui.inputY.value = null;
    }

    getCoordinates() {
        const xVal = parseFloat(this.ui.inputX.value);
        const yVal = parseFloat(this.ui.inputY.value);
        this.resetTeleportInputs();

        if (isNaN(xVal) || isNaN(yVal)) {
            console.log("Please enter valid numbers for both X and Y.");
            return null;
        }

        return { x: xVal, y: yVal };
    }


    setupGridInteractions() {
        // Instead of individual tile event listeners, listen to the parent container once!
        this.ui.gridContainer.addEventListener("click", (e) => {
            // Find the closest grid item that was clicked
            const tileEl = e.target.closest(".grid-item, .grid-item-center");
            if (!tileEl || tileEl.classList.contains("empty-world-slot")) return;

            const x = parseInt(tileEl.dataset.x, 10);
            const y = parseInt(tileEl.dataset.y, 10);

            const offset = Math.floor(this.currentMapSize / 2);
            const centerX = this.gameState.map.centerX;
            const centerY = this.gameState.map.centerY;

            const isCenter = (x === centerX && y === centerY);

            if (isCenter) {
                this.uiManager.toggleMainMenu('tile');
            } else {
                this.gameState.moveCenter(x, y);
                this.drawGrid();
            }
        });
    }

    drawGrid() {
        let centerX = this.gameState.map.centerX;
        let centerY = this.gameState.map.centerY;
        this.updateNavPlaceholders(centerX, centerY);

        let gridSize = this.currentMapSize;
        const offset = Math.floor(gridSize / 2);

        // Calculate total elements needed for the grid layout
        const totalTargetCells = gridSize * gridSize;

        // If the zoom level changed, reset container child elements 
        if (this.ui.gridContainer.children.length !== totalTargetCells) {
            this.ui.gridContainer.innerHTML = '';
            this.ui.gridContainer.style.setProperty('--grid-rows', gridSize);
            this.ui.gridContainer.style.setProperty('--grid-cols', gridSize);
        }

        let cellIndex = 0;

        for (let y = 0; y < gridSize; y++) {
            for (let x = 0; x < gridSize; x++) {
                const worldX = centerX + (x - offset);
                const worldY = centerY + (y - offset);
                const isCenter = (x === offset && y === offset);

                const playersOnTile = Array.from(network.players.values()).filter(p => {
                    const isLocal = network.socket && p.userId === network.socket.id;
                    return !isLocal && p.xPos === worldX && p.yPos === worldY;
                });

                const tile = this.gameState.worldHandler.getActiveWorld()?.getTile(worldX, worldY);
                const existingCell = this.ui.gridContainer.children[cellIndex] || null;

                const tileEl = elementFactory.createTile(tile, isCenter, this.currentMapSize, existingCell, playersOnTile);

                if (!existingCell) {
                    this.ui.gridContainer.appendChild(tileEl);
                }

                cellIndex++;
            }
        }
    }

    updateUI() {
        let currentMP = this.gameState.player.stats.magicPower;
        if (currentMP.neq(this.lastMPValue)) {
            this.lastMPValue = currentMP;
            this.mpText.innerText = currentMP.toFixed(0);
        }
        if (this.gameState.uiInfo.worldSwap) {
            this.gameState.uiInfo.worldSwap = false;
            this.drawGrid();
        }
    }
}